import { all } from '@redux-saga/core/effects';

import watchNotifData from './data';
import watchNotifQBuilder from './qbuilder';

export default function* watchNotifier() {
    yield all([watchNotifData(), watchNotifQBuilder()]);
}
